const focTarget = document.getElementsByTagName('body')[0];

let focusedElement;

const config = {attributes: true, childList: false, subtree: false};

const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'attributes') {
      if (focTarget.classList.contains('modal-open')) {
        focusedElement = document.activeElement;
      } else if (focusedElement) {
        focusedElement.focus();
      }
    }
  }
};
const retainFocus = function() {
  const observer = new MutationObserver(callback);
  observer.observe(focTarget, config);
};
export default retainFocus;
